import { Button, H3, H4, H5 } from '@/components';
import CommonBlok from '@/components/common-blok';
import { LoadingImageUrl, WEB_APP_JP_SIGN_UP_URL } from '@/constants';
import React from 'react';
import { EditShareInfo, TransWorkspaceList } from '../../constants';
import * as styles from './index.module.less';

const CanDo = () => {
  const SHORT_FORMAT_TITLE = 'エクスポート';

  return (
    <CommonBlok title="Nottaができること" paddingBottom="0px" isNewLayout>
      <div className={styles.blok_content}>
        <div className={styles.cards_layout}>
          <div className={styles.edit_share_card}>
            <H3>{EditShareInfo.title}</H3>
            <div className={styles.text_pic_container}>
              <div className={styles.text_container}>
                <p className={styles.edit_share_desc}>{EditShareInfo.description}</p>
                <div className={styles.features_list_group}>
                  {EditShareInfo.featureListGroup.map((item) => {
                    return (
                      <div className={styles.features_list} key={item.title}>
                        <H5 style={{ marginBottom: '0' }}>{item.title}</H5>
                        <ul>
                          {item.featureList.map((item, index) => {
                            return (
                              <li key={index}>
                                <p>{item}</p>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={styles.pic_container}>
                <img
                  className="lozad"
                  src={LoadingImageUrl}
                  data-src={EditShareInfo.withPic.src}
                  alt={EditShareInfo.withPic.alt}
                />
              </div>
            </div>
            <div className={styles.support_format}>
              {EditShareInfo.formatGroup.map((item, index) => {
                return (
                  <div key={index} className={styles.format_title_list_container}>
                    <H4
                      className={`${styles.format_title} ${
                        item.title === SHORT_FORMAT_TITLE && styles.short_format_title
                      }`}
                    >
                      {item.title}
                    </H4>
                    <div className={styles.format_list}>
                      {item.list.map((item, index) => {
                        return (
                          <div key={index} className={styles.format_item}>
                            {item}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {TransWorkspaceList.map((item, index) => {
            return (
              <div key={index} className={styles.trans_workspace_container}>
                <div className={styles.trans_workspace_card_cover}>
                  <img className="lozad" src={LoadingImageUrl} data-src={item.withPic.src} alt={item.withPic.alt} />
                </div>
                <div className={styles.trans_workspace_content}>
                  <H3>{item.title}</H3>
                  {item.description.map((textItem, index) => {
                    if (textItem.type === 'paragraph') {
                      return <p key={index}>{textItem.text}</p>;
                    }
                    if (textItem.type === 'ul') {
                      return (
                        <ul key={index}>
                          {textItem.text.map((liItem, liIndex) => {
                            return (
                              <li key={liIndex}>
                                <p>{liItem}</p>
                              </li>
                            );
                          })}
                        </ul>
                      );
                    }
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.btn_container}>
          <a href={WEB_APP_JP_SIGN_UP_URL} data-gtm="home-page-notta-feature-sign-up-btn">
            <Button>無料ではじめる</Button>
          </a>
          <a href="/about" data-gtm="home-page-notta-feature-about">
            <Button type="primary">法人向けのお問い合わせ</Button>
          </a>
        </div>
      </div>
    </CommonBlok>
  );
};
export default CanDo;
